import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { LoaderScreen } from "../../components/LoaderScreen";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
export const ProyeccionRecuperacionCarteraDetalle = () => {
  const location = useLocation();
  const history = useHistory();
  const [loader, setLoader] = useState({
    mostrar: true,
    alerta: false,
    error: false,
    mensaje: "",
  });
  const [data, setData] = useState([]);
  const [totales, setTotales] = useState({});
  useEffect(() => {
    const post = {
      inicio: location.state.fechainicio,
      fin: location.state.fechafinal,
      idsucursal: location.state.idsucursal,
      lineacredito: location.state.lineacredito,
      cartera: location.state.mostrarcartera,
    };
    request
      .post("RecuperacionCartera/ObtenerDetalle", post)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setData(result.data);
        setTotales(result.totales);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("RECUPERACION DE CARTERA", JSON.stringify(error), "error");
      });
  }, []);
  const onTitulo = () => {
    return `DETALLE DE CARTERA ${
      location.state.lineacredito === "RV"
        ? " REVOLVENTE "
        : location.state.lineacredito === "OP"
        ? " DE OPERACION "
        : " CONSOLIDADA "
    } 
     ${location.state.sucursal}
    ${
      location.state.mostrarcartera === "VN" ? " VENCIDA" : "POR VENCER"
    } DEL ${new Date(location.state.fechainicio).toLocaleDateString(
      "es-mx"
    )} AL ${new Date(location.state.fechafinal).toLocaleDateString("es-mx")}`;
  };
  const capitalizeWords = (str) => {
    return str ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()) : "";
  }; 
  if (data === undefined || data === null || data.length === 0)
    return <div></div>;
  return (
    <div className="recuperacion-cartera-detalle">
      <LoaderScreen loader={loader} />
      <div className="recuperacion-cartera-detalle-titulo">
        <div
          className="recuperacion-cartera-detalle-titulo-back"
          onClick={() =>
            history.push(
              "/Creditoycobranza/Main",
              location.state
            )
          }
        >
          <ArrowBackIcon />
          Regresar
        </div>
        <div className="recuperacion-cartera-detalle-titulo-label">
          {" "}
          {onTitulo()}{" "}
        </div>
      </div>
      <div className="recuperacion-cartera-detalle-container-table scroll">
        <table cellPadding={0} cellSpacing={0}>
          <thead>
            <tr>
              <th>Cliente</th>
              <th>
                <div>Razón Social</div>
              </th>
              <th>
                <div>Serie</div>
              </th>
              <th>
                <div>Folio</div>
              </th>
              <th>
                <div>Fecha</div>
              </th>
              <th>
                <div>Total</div>
              </th>
              <th>
                <div>Abonos</div>
              </th>
              <th>
                <div>Saldo Inicial</div>
              </th>
              <th>
                <div>Recuperado</div>
              </th>
            </tr>
          </thead>
          <tbody>
            {data.map((item) => (
              <tr>
                <td>{item.idcliente}</td>
                <td>{capitalizeWords(item.razonsocial)}</td>
                <td>{item.serie}</td>
                <td>{item.folio}</td>
                <td>{item.strfecha}</td>
                <td>{FormatMoney(item.facturado, 2)}</td>
                <td>{FormatMoney(item.abono)}</td>
                <td>{FormatMoney(item.saldo)}</td>
                <td>{FormatMoney(item.recuperado)}</td>
              </tr>
            ))}
            <tr>
              <td colSpan={5}>TOTAL</td>
              <td>{FormatMoney(totales.facturado)}</td>
              <td>{FormatMoney(totales.abono)}</td>
              <td>{FormatMoney(totales.saldo)}</td>
              <td>{FormatMoney(totales.recuperado)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};
